// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_2hF","cls2":"TranslationModal-cls2_JMh TranslationModal-cls1_2hF"};